/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
/* global fetch, localStorage */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { SEND_BIOMETRY_REQUEST, success, failure } from './action';

const events = (action$, state, { AjaxRequest }) =>
  action$
    .ofType(SEND_BIOMETRY_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ id, file }) => {
      const formData = new FormData();

      formData.append('faceCheckImageFile', file);

      return AjaxRequest.open('post', `/admin/contractcustom/contracts/${id}/facerecognition`, formData, {
        noContentType: true,
      })('tudo')
        .flatMap((response) => Observable.of(success(response)))
        .catch((err) => Observable.of(failure(err)));
    });

export default combineEpics(events);
